import React, { useEffect, useState } from 'react';

//*MUI
import PlusIcon from '../Icons/PlusIcon';
import { DataGrid } from '@mui/x-data-grid';

//*files
import cssClasses from './HoldMasters.module.css';
import Button from '../../Subcomponents/Button';
import EmptyState from '../../Assets/Images/Common/noProjectFound.svg';
import EditIcon from '../../Assets/Images/Common/EditIcon.svg';
import { useSelector } from 'react-redux';
import { dismissLoader, presentLoader } from '../../Services/loader';
import {
  getHoldDetails,
  getHoldDetailsFromServer,
  insertHoldDetails,
  updateHoldDetails,
} from '../../Services/Bank';
import { errorTost, successTost } from '../../Services/Toast';
import { Box, Tooltip } from '@mui/material';
import AddHoldDetailsModal from './AddHoldDetailsModal/AddHoldDetailsModal';

export const dataGridStyles = {
  '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  border: '1px solid #EAECF0 !important',
  fontWeight: '400',
  fontSize: '1.4rem',
  lineHeight: '2rem',
  color: '#667085',
  fontFamily: 'Inter-Medium',
  borderRadius: '8px',
  '& div[data-colindex="1"]': {
    color: '#101828',
    fontWeight: '500',
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    '& .MuiDataGrid-row': {
      borderBottom: '1px solid #EAECF0',
      background: '#FFFFFF',
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: '1rem',

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    '& .MuiDataGrid-row.Mui-selected:hover': {
      borderBottom: '1px solid #EAECF0',
      backgroundColor: '#FFFFFF',
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  '& .MuiDataGrid-iconSeparator ': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeader:hover': {
    '& .MuiDataGrid-menuIcon': {
      visibility: 'hidden',
    },
  },
  '& .MuiDataGrid-columnHeaders + div': {
    height: 'calc(100vh - 315px) !important',
  },
  '&  .MuiDataGrid-columnHeaders': {
    background: '#F9FAFB',
    /* Gray/200 */
    border: '1px solid #EAECF0',
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: '1rem',
    borderBottom: '6px solid #EAECF0',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-checkboxInput': {
    '& svg': {
      width: '2rem',
      height: '2rem',
      background: '#FFFFFF',
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  '& .MuiDataGrid-footerContainer': {
    '& .MuiTablePagination-displayedRows ': {
      display: 'none',
    },
    '& .MuiDataGrid-selectedRowCount': {
      visibility: 'hidden ',
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: 'none',
    cursor: 'none',
  },
  "& [title='Go to previous page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to next page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: '1rem',
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: '1rem',
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 4rem',

    '&:focus': {
      outline: 'none',
    },
  },
  '&  .MuiDataGrid-row ': {
    maxHeight: '72px !important',
    minHeight: '72px !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 4rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiButtonBase-root': {
    fontSize: '1.6rem',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 2rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 1rem',

    '&:focus': {
      outline: 'none',
    },
  },
};

function HoldMaster() {
  const loggedInUser = useSelector((state) => state.Auth.user);
  const [allHoldData, setAllHoldData] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(12);
  const [selectedHoldDetails, setSelectedHoldDetails] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [showAddHoldDetailsModal, setShowAddHoldDetailsModal] =
    useState(false);
  const [pageMaintain, setPageMaintain] = useState(0);

  const tagGridColumns = [
    {
      field: 'action',
      headerName: '',
      width: window.innerWidth < 820 ? 50 : 100,
      renderCell: (params) => {
        return (
          <div style={{ cursor: 'pointer' }}>
            <Tooltip
              placement='bottom-start'
              title={<Box fontSize={'1.5rem'}>Edit</Box>}
            >
              <p
                style={{
                  whiteSpace: 'normal',
                  lineBreak: 'anywhere',
                  opacity: '0.7',
                }}
              >
                <img
                  src={EditIcon}
                  alt='edit'
                  onClick={() => {
                    setIsEdit(true);
                    setSelectedHoldDetails(params?.row);
                    setShowAddHoldDetailsModal(true);
                  }}
                />
              </p>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: 'HoldTypes',
      headerName: 'Hold Types',
      width: window.innerWidth < 820 ? 160 : 250,
      renderCell: (params) => {
        return <div>{params?.row?.HoldType}</div>;
      },
    },
    // s
  ];

  useEffect(() => {
    getAllHoldTypes(0, false);
  }, []);

  function getAllHoldTypes(pageNumber, merge) {
    getHoldDetailsFromServer(
      pageNumber * pageSize,
      pageNumber * pageSize + pageSize - 1
    )
      .then((holdRes) => {
        const _arr = holdRes.data.map((el, index) => ({
          ...el,
         id: el.HoldTypeId,
          index: index,
        }));
        if (merge) {
          setAllHoldData((pre) => [...pre, ..._arr]);
        } else {
          setAllHoldData([..._arr]);
        }
      })
      .catch((err) => {
        dismissLoader();
        if (err?.message) {
          errorTost(err?.message);
        } else {
          errorTost('Something went wrong! Try again');
        }
      });
  }

function capitalizeFirstLetter(str) {
  if (!str) return ''; 
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function containsSpecialCharacters(str) {
  const regex = /[^a-zA-Z0-9\s]/; 
  return regex.test(str);
}

function SaveIntoHoldTable(val, isUpdate) {
  presentLoader();
  if (isUpdate && !selectedHoldDetails) {
    dismissLoader();
    errorTost("Selected hold details not found.");
    return;
  }

  const holdType = capitalizeFirstLetter(val?.HoldType);

  if (containsSpecialCharacters(holdType)) {
    dismissLoader();
    errorTost("Hold Type contains special characters. Please enter a valid value.");
    return;
  }

  getHoldDetails(holdType)
    .then((typeRes) => {
      console.log('typeRes', typeRes);
      if (typeRes.data.length > 0 && typeRes?.data[0]?.HoldTypeId !== selectedHoldDetails?.HoldTypeId) {
        dismissLoader();
        errorTost('Hold type already exists');
      } else {
        if (isUpdate) {
          const updatePayload = {
            HoldType: holdType,
            lastUpdatedBy: loggedInUser?.userId,
            last_updated_at: new Date().getTime(),
            // description: val?.description
          };
          updateHoldDetails(updatePayload, selectedHoldDetails?.HoldTypeId)
            .then((res) => {
              dismissLoader();
              successTost('Hold type updated successfully!');
              getAllHoldTypes(0, false);
            })
            .catch((err) => {
              dismissLoader();
              errorTost(err.message);
            });
        } else {
          const addPayload = {
            HoldType: holdType,
            lastUpdatedBy: loggedInUser?.userId,
            addedBy: loggedInUser?.userId,
            // description: val?.description
          };
          insertHoldDetails(addPayload)
            .then((resp) => {
              dismissLoader();
              successTost('Hold type added successfully!');
              getAllHoldTypes(0, false);
            })
            .catch((err) => {
              dismissLoader();
              errorTost(err.message);
            });
        }
      }
    })
    .catch((err) => {
      dismissLoader();
      errorTost(err.message);
    });
}
  function getMoreData(passPageNumber) {
    setPageNumber(passPageNumber);
    getAllHoldTypes(passPageNumber, true);
  }
  return (
    <div className={cssClasses.wrapperPage}>
      <div className={cssClasses.wrapperContent}>
        <div className={cssClasses.wrapperSubContent}>
          <div className={cssClasses.addButton}>
            <Button
              style={{
                color: '#FFFFFF',
                backgroundColor: '#155EEF',
                fontSize: '1.6rem',
                lineHeight: '2.4rem',
                width: '20rem',
              }}
              btnIcon={<PlusIcon />}
              iconPosition={'left'}
              btnName={'Add Hold Type'}
              clicked={() => {
                setIsEdit(false);
                setSelectedHoldDetails(null);
                setShowAddHoldDetailsModal(true);
              }}
            />
          </div>
          <div style={{ margin: '1rem' }}>
            {allHoldData?.length > 0 ? (
              <DataGrid
                rows={allHoldData}
                columns={tagGridColumns}
                pageSize={10}
                rowsPerPageOptions={[10]}
                page={pageMaintain}
                onPageChange={(_page) => {
                  setPageMaintain(_page);
                  if (pageNumber < _page) {
                    getMoreData(_page);
                  }
                }}
                sx={[dataGridStyles]}
              />
            ) : (
              <div style={{ height: '400px' }}>
                <p
                  style={{
                    position: 'relative',
                    top: '50%',
                    textAlign: 'center',
                    fontSize: '3rem',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <img src={EmptyState} alt='No Data' />
                    <span>No Hold Types Available</span>
                  </div>
                </p>
              </div>
            )}
          </div>
        </div>

        {showAddHoldDetailsModal && (
          <AddHoldDetailsModal
            open={showAddHoldDetailsModal}
            handleClose={() => {
              setShowAddHoldDetailsModal(false);
            }}
            isEdit={isEdit}
            selectedHoldDetails={selectedHoldDetails}
            handleSave={(val, isUpdate) => {
              setShowAddHoldDetailsModal(false);
              SaveIntoHoldTable(val, isUpdate);
            }}
          />
        )}
      </div>
    </div>
  );
}


export default HoldMaster;
